function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M108.062 0.64978H11.9417C8.77925 0.652639 5.74716 1.91009 3.51088 4.14614C1.2746 6.3822 0.0168492 9.41416 0.0136719 12.5766V104.497C0.0171657 107.658 1.27473 110.69 3.51046 112.925C5.74618 115.161 8.77748 116.419 11.9393 116.422H108.059C111.221 116.419 114.253 115.162 116.49 112.926C118.726 110.69 119.984 107.659 119.987 104.497V12.5766C119.984 9.41458 118.727 6.38298 116.491 4.14699C114.255 1.91101 111.224 0.653275 108.062 0.64978ZM110.28 104.497C110.28 105.084 110.046 105.647 109.631 106.062C109.216 106.478 108.653 106.711 108.065 106.712H11.9453C11.6536 106.713 11.3647 106.656 11.095 106.545C10.8252 106.434 10.58 106.271 10.3734 106.066C10.1667 105.86 10.0027 105.615 9.89065 105.346C9.77861 105.077 9.72078 104.788 9.72047 104.497V38.6442H110.28V104.497ZM110.28 28.9314H9.72047V12.5766C9.72063 12.2854 9.77814 11.997 9.88973 11.728C10.0013 11.459 10.1648 11.2147 10.3708 11.0089C10.5769 10.803 10.8214 10.6398 11.0905 10.5285C11.3597 10.4172 11.6481 10.36 11.9393 10.3602H108.059C108.351 10.3597 108.639 10.4167 108.909 10.5278C109.178 10.639 109.423 10.8022 109.629 11.008C109.836 11.2138 109.999 11.4583 110.111 11.7275C110.223 11.9966 110.28 12.2852 110.28 12.5766V28.9314Z",
  fill: "#EEF0F2"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8647 14.7905H14.1543V24.5009H23.8647V14.7905Z",
  fill: "#EEF0F2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.0053 14.7905H28.2949V24.5009H38.0053V14.7905Z",
  fill: "#EEF0F2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M106.205 14.7905H96.4941V24.5009H106.205V14.7905Z",
  fill: "#EEF0F2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0627 77.5338H28.0094V88.1406H37.7198V77.5338H44.7914V67.8234H37.7198V57.2166H28.0094V67.8234H24.9251V57.2166H15.2051V72.6785C15.2067 73.9662 15.719 75.2005 16.6297 76.1108C17.5404 77.021 18.7751 77.5328 20.0627 77.5338Z",
  fill: "#EEF0F2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M80.0906 77.5338H88.0362V88.1406H97.7478V77.5338H104.818V67.8234H97.7478V57.2166H88.0362V67.8234H84.9458V57.2166H75.2402V72.6785C75.2418 73.9649 75.7532 75.1982 76.6623 76.1083C77.5715 77.0183 78.8043 77.5309 80.0906 77.5338Z",
  fill: "#EEF0F2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M60.0133 88.1405C63.1752 88.1367 66.2065 86.8789 68.4422 84.643C70.6779 82.4071 71.9354 79.3757 71.9389 76.2137V69.1434C71.9547 67.5671 71.6579 66.0034 71.0657 64.5426C70.4734 63.0817 69.5975 61.7528 68.4885 60.6326C67.3794 59.5124 66.0594 58.6232 64.6045 58.0163C63.1497 57.4094 61.5891 57.0969 60.0127 57.0969C58.4364 57.0969 56.8757 57.4094 55.4209 58.0163C53.9661 58.6232 52.646 59.5124 51.537 60.6326C50.428 61.7528 49.552 63.0817 48.9598 64.5426C48.3675 66.0034 48.0707 67.5671 48.0865 69.1434V76.2137C48.09 79.3759 49.3477 82.4075 51.5837 84.6434C53.8196 86.8794 56.8512 88.1371 60.0133 88.1405ZM57.7969 69.1434C57.7901 68.848 57.8423 68.5543 57.9506 68.2795C58.0588 68.0046 58.2209 67.7542 58.4274 67.5429C58.6338 67.3316 58.8804 67.1637 59.1527 67.0491C59.4249 66.9344 59.7173 66.8754 60.0127 66.8754C60.3081 66.8754 60.6006 66.9344 60.8728 67.0491C61.1451 67.1637 61.3917 67.3316 61.5981 67.5429C61.8045 67.7542 61.9666 68.0046 62.0749 68.2795C62.1832 68.5543 62.2354 68.848 62.2285 69.1434V76.2137C62.2151 76.7925 61.9757 77.343 61.5616 77.7475C61.1476 78.1521 60.5916 78.3786 60.0127 78.3786C59.4338 78.3786 58.8779 78.1521 58.4638 77.7475C58.0498 77.343 57.8104 76.7925 57.7969 76.2137V69.1434Z",
  fill: "#EEF0F2"
});

const SvgNotFound = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 118,
  viewBox: "0 0 120 118",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotFound, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NotFound.f29843d4.svg";
export { ForwardRef as ReactComponent };